import DashboardLayout from '@/layouts/DashboardLayout';
import OwnKPI from './_components/OwnKPI';

export default function EmployeeKPI() {
  return (
    <DashboardLayout title="Employee KPI">
      <OwnKPI />
    </DashboardLayout>
  );
}
